import Vue from 'vue'
import VideoOption from './video.vue'

const Video = Vue.extend(VideoOption)

export function templateVideoVue({ module, exposeDirective }) {
  const video = new Video({
    propsData: {
      module
    },
    directives: {
      tangramExpose: exposeDirective
    }
  }).$mount()
  return video.$el
}
